export const GET_VIRTUAL_RESULTS = 'GET_VIRTUAL_RESULTS';
export const GET_CLASSIC_RESULTS = 'GET_CLASSIC_RESULTS';

export const VIEWPORT_OBSERVABLE = 'observable-loader';
